export function AssetHeader({ eyebrow, title, description }) {
  return (
    <header>
      <p className="mw-eyebrow">{eyebrow}</p>
      <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">{title}</h1>
      <p className="mt-3 max-w-xl text-sm text-muted-foreground sm:text-base">{description}</p>
    </header>
  );
}

export function downloadBlob(blob, filename) {
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}
